import { render, staticRenderFns } from "./Fee.vue?vue&type=template&id=db70aa74&scoped=true"
import script from "./Fee.vue?vue&type=script&lang=js"
export * from "./Fee.vue?vue&type=script&lang=js"
import style0 from "./Fee.vue?vue&type=style&index=0&id=db70aa74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db70aa74",
  null
  
)

export default component.exports